export default __webpack_public_path__ + "static/media/yt_nibiru-ep3.f1dd1662.jpg";